import { render, staticRenderFns } from "./XhtmlString.vue?vue&type=template&id=5968780c"
import script from "./XhtmlString.vue?vue&type=script&lang=js"
export * from "./XhtmlString.vue?vue&type=script&lang=js"
import style0 from "./XhtmlString.vue?vue&type=style&index=0&id=5968780c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports